"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PING_TIMEOUT = exports.StreamReconnectIntervals = exports.STREAM_FIRST_REQUEST_ID = exports.StreamConnectionEvent = void 0;
const state_1 = require("../../state");
const util_1 = require("../../util");
const AuthenticationSuccess = 'authenticationSuccess';
const AuthenticationFailed = 'authenticationFailed';
exports.StreamConnectionEvent = Object.assign(Object.assign({}, state_1.StateEvent), { AuthenticationFailed, AuthenticationSuccess });
exports.STREAM_FIRST_REQUEST_ID = 1;
exports.StreamReconnectIntervals = {
    [util_1.Environment.WEB]: [5, 10, 15],
    [util_1.Environment.NODEJS]: [5, 10, 15, 5 * 60, 15 * 60, 60 * 60, 120 * 60],
};
exports.PING_TIMEOUT = 30;
